module.exports = __webpack_public_path__ + "img/klcx_06.5ae8c190.jpg";